// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + "874c87d9512942af1703" + ".js";
};